import http from '@/http'

export default {
  todoCount() {
    return http.get('/asset/except-report/todo/count')
  },
  page(params) {
    return http.get('/asset/except-report/page', { params })
  },
  detail(id) {
    return http.get(`/asset/except-report/detail/${encodeURIComponent(id)}`)
  },
  assignableHandlers() {
    return http.get('/asset/except-report/assignable-handlers')
  },
  report(data) {
    return http.post('/asset/except-report/report', data)
  },
  accept(id, data) {
    return http.put(`/asset/except-report/${id}/accept`, data)
  },
  handleFinish(id, data) {
    return http.put(`/asset/except-report/${id}/handle-finish`, data)
  },
  confirm(id, data) {
    return http.put(`/asset/except-report/${id}/confirm`, data)
  },
  reject(id, data) {
    return http.put(`/asset/except-report/${id}/reject`, data)
  },
  cancel(id, data) {
    return http.put(`/asset/except-report/${id}/cancel`, data)
  },
  uploadAttachment(formData) {
    return http.post('/asset/except-report/attachment/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  }
}
